// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingGlobal_container__Fv2RJ","loading":"LoadingGlobal_loading__37r96"};